<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" small class="info-icon mr-2">mdi-account</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Nuevo Contacto</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-4">
								<v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newUserData.user_name"
                    label="Nombre"
                    placeholder="Ingrese nombre del usuario"
                    outlined
                    required
                    dense
										:disabled="originalUserData?.user_name?.trim() !== '' && newUserData.disable_user"
                    :rules="requiredRule"
                  ></v-text-field>
									<v-row>
										<v-col cols="6" class="py-0">
											<v-text-field
												v-model="newUserData.lastname"
												label="Primer Apellido"
												placeholder="Ingrese primer apellido del usuario"
												outlined
												required
												dense
												:disabled="originalUserData?.lastname?.trim() !== '' && newUserData.disable_user"
												:rules="requiredRule"
											></v-text-field>
										</v-col>
										<v-col cols="6" class="py-0">
											<v-text-field
												v-model="newUserData.second_lastname"
												label="Segundo Apellido"
												placeholder="Ingrese segundo apellido del usuario"
												outlined
												required
												dense
												:disabled="originalUserData?.second_lastname?.trim() !== '' && newUserData.disable_user"
												:rules="requiredRule"
											></v-text-field>
										</v-col>
									</v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newUserData.user_email"
                    label="Email"
                    placeholder="Ingrese email del usuario"
                    outlined
                    required
                    dense
										:disabled="newUserData.disable_user"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newUserData.user_phone"
                    label="Teléfono"
                    placeholder="Ingrese teléfono del usuario (Ej: 56912345678)"
                    outlined
                    required
                    dense
                    :rules="phoneRule"
										maxlength="11"
										@keypress="isNumberKey"
                  ></v-text-field>
                </v-col>
								<v-col cols="12" class="py-0">
									<div class="mb-4">
										<ProjectTypeSelectorMenuSelect
												:fullView="true"
												:denseInput="false"
												:projectType="projectType"
												:onClick="(project_type) => { changeProjectType(project_type) }"/>
									</div>
									<!-- <v-combobox
										v-model="projectType"
										:items="projectTypeOptions"
										:filter="customFilter"
										:loading="$store.state.companies.loadingCompaniesProjectTypes"
										item-text="name"
										item-value="value"
										dense
										outlined
										label="Selecciona tipo de proyecto"
										clearable
									>
										<template v-slot:item="{ item }">
											<div v-if="item.header" class="font-weight-bold caption">
												{{ item.header }}
											</div>
											<div v-else-if="item.isSubType" class="caption ml-2">
												{{ item.name }}
											</div>
											<div v-else class="caption font-weight-bold">
												{{ item.name }}
											</div>
										</template>
									</v-combobox> -->
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newUserData.project_detail"
                    label="Proyecto"
                    placeholder="Detalle Proyecto"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
								<v-col class="py-1" cols="12">
									<v-autocomplete
										v-model="newUserData.address"
										:items="[...items, ...[newUserData.address]]"
										name="address"
										:search-input.sync="search"
										prepend-inner-icon="mdi-map-marker"
										label="Dirección"
										placeholder="Dirección"
										autocomplete="off"
										outlined
										dense
										hide-details
										:loading="loading"
										:filter="d => d"
										color="secondary"
										item-color="secondary"
										return-object
										@change="change"
									></v-autocomplete>
								</v-col>
							</v-row>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import {addCrmEntry} from '@/helpers/api/crm'
import ProjectTypeSelectorMenuSelect from '@/components/Helpers/Components/ProjectTypeSelectorMenuSelect'

export default {
  name: 'NewCrmContactModal',
  components: { ProjectTypeSelectorMenuSelect },
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		items: [],
		loading: false,
		autocompleteService: null,
		search: '',
		originalUserData: null,
		projectType: null,
    newUserData: {
      user_email: null,
      user_name: null,
			lastname: null,
			second_lastname: null,
      user_phone: null,
			project_detail: null,
			address: null,
			coordinates: null,
			project_type_id: null
    },
    loadingData: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
    phoneRule: [
			v => !!v || 'Campo requerido',
			v => /^569\d{8}$/.test(v) || 'Debe tener 11 dígitos y empezar con 569',
    ],
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ],
  }),
  computed: {
		projectTypeOptions() {
			const options = [];
			if(!this.$store.state.companies.companiesProjectTypesCategories) return options
			this.$store.state.companies.companiesProjectTypesCategories.forEach(category => {
				options.push({ header: category.name });
				category.project_types.forEach(pt => {
					options.push({ name: pt.name, value: pt.id, isParent: true, sub_types: pt.sub_types });
					pt.sub_types.forEach(st => {
						options.push({ name: st.name, value: st.id, isSubType: true });
					});
				});
			});
			return options;
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		google: gmapApi,
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
    search(newSearch) {
      if (newSearch) {
        this.googleSearch(newSearch);
      } else {
        this.items = [];
      }
    },
	},
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.$nextTick(() => {
			this.$gmapApiPromiseLazy().then(() => {
				this.autocompleteService = new this.google.maps.places.AutocompleteService()
			})
			if(this.$store.state.crm.newContactModalData){
				this.newUserData = {...this.$store.state.crm.newContactModalData}
				this.originalUserData = {...this.$store.state.crm.newContactModalData}
			}
		});
  },
  methods: {
		changeProjectType(project_type){
			this.projectType = project_type
		},
		customFilter(item, queryText, itemText) {
			if (item.header) return true;
			const text = (itemText || '').toLowerCase();
			const query = queryText.toLowerCase();
			if (text.includes(query)) return true;
			if (item.isParent && item.sub_types?.some(st => st.name.toLowerCase().includes(query))) {
				return true;
			}
			return false;
		},
    googleSearch(query) {
      const options = {
        input: query,
				componentRestrictions: { country: 'CL' }
      };
      this.autocompleteService.getPlacePredictions(options, (predictions, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.items = predictions.map(prediction => ({
            text: prediction.description,
            value: prediction 
          }));
        } else {
          console.error('Error fetching predictions: ', status);
          this.items = [];
        }
      });
    },
		async getPlaceDetails(placeId) {
			if (typeof this.google !== 'undefined' && this.google.maps) {
				const service = new this.google.maps.places.PlacesService(document.createElement('div'));
				
				service.getDetails({ placeId }, (place, status) => {
					if (status === this.google.maps.places.PlacesServiceStatus.OK) {
						const { geometry } = place;
						this.newUserData.coordinates = {
							lat: geometry.location.lat(),
							lng: geometry.location.lng()
						}
					}
				});
			} else {
				console.error('Google Maps API no está cargada');
			}
		},
    change(value) {
			this.getPlaceDetails(value.value.place_id)
      this.newUserData.address = value.text;
    },
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
    closeModal(){
			this.$store.commit('crm/setNewContactModal', false)
			this.$store.commit('crm/setNewContactModalData', null)
      this.newUserData = {
				user_email: null,
				user_name: null,
				lastname: null,
				second_lastname: null,
				user_phone: null,
				project_detail: null,
				address: null,
				coordinates: null,
				project_type_id: null
			}
      this.validform = true
      this.loadingData = false	
    },
    async sendForm(){
      if(this.$refs.form.validate()){
        this.loadingData = true
				try {
					this.newUserData.project_type_id = this.projectType.id
					const crm = await addCrmEntry(this.newUserData)
					if(crm.code === 200){
						const messageData = {
							message: 'Se ha creado correctamente el contacto',
							title: 'Contacto creado',
							type: 'success',
							icon: 'mdi-check-circle',
							color: '#3EBFA3',
						}
						this.$router.push({ name: 'Conversation', params: { id: crm.conversation.id } })
						this.setMessage(messageData)
						this.closeModal()
					}
				} catch (error) {
					if(error.data){
						error.data.forEach(message => {
							const messageData = {
								message: message.message,
								title: 'Error',
								type: 'danger',
								icon: 'mdi-close-octagon',
								color: '#FF1209',
							}
							this.setMessage(messageData)
						})
					}
				}
        this.loadingData = false
      }
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding-bottom: 10px;
		padding-top: 3px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>